/**
 * Created by zhoay on 2023/5/15
 * Desc: 订购详情
 */
import React, { Component } from 'react'
import { List, Toast, Form, Stepper } from "antd-mobile";
import { API } from '../../../configs/api.config'
import { connect } from 'react-redux'
import phone_img from '../../../style/imgs/phone_icon.png';

class PreviewPage extends Component {

    componentWillMount() {
        document.title = "订购详情";
    }

    constructor(props) {
        super(props)

        this.state = {
            status: this.props.match.params.type,
        }
    }

    componentDidMount() {


    }

    render() {
        const { status } = this.state;
        return (
            <div style={{ position: 'relative', width: '6.3rem', height: '2.46rem' }}>
                {status === '1' ?
                <div style={{position: 'absolute', background: 'transparent', width: '100vw', height: '100vh', top: 0, left: 0}}>
                    <div style={{height: '25vh'}}></div>
                    <div style={{textAlign: 'center'}}>定制已成功</div>
                </div>:
                status === '2' ?
                <div style={{position: 'absolute', background: 'transparent', width: '100vw', height: '100vh', top: 0, left: 0}}>
                    <div style={{height: '25vh'}}></div>
                    <div style={{textAlign: 'center'}}>定制失败</div>
                    <a href={'tel:' + 15388765510} style={{textAlign: 'center'}}>
                        <div style={{alignItems: 'center',color:'#4197FC'}}><span style={{color:'#000'}}>{'请联系客服：'}</span>{15388765510}<img style={{height: 14, marginLeft: 10}} src={phone_img} alt=""/></div>
                    </a>
                </div>:
                status === '0' ?
                <div style={{position: 'absolute', background: 'transparent', width: '100vw', height: '100vh', top: 0, left: 0}}>
                    <div style={{height: '25vh'}}></div>
                    <div style={{textAlign: 'center'}}>班级订购已取消</div>
                    <div style={{textAlign: 'center'}}>第一批订购已在制作，第二批订购请等待学校通知</div>
                    <div style={{height: '2vh'}}></div>
                    <div style={{textAlign: 'center'}}>详情请联系：
                        <a href={'tel:' + 15388765510} >
                            <div style={{alignItems: 'center', color:'#4197FC'}}>{15388765510}<img style={{height: 14, marginLeft: 10}} src={phone_img} alt=""/></div>
                        </a>
                    </div>
                </div>:
                <div style={{position: 'absolute', background: 'transparent', width: '100vw', height: '100vh', top: 0, left: 0}}>
                    <div style={{height: '25vh'}}></div>
                    <div style={{textAlign: 'center'}}>学校已停止订购</div>
                </div>
                }
            </div>
        )
    }

}

let mapStateToProps = (state) => ({
    userInfo: { ...state.redUserInfo }
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(PreviewPage)
